/*
Component: Menu
Purpose: 
It is the main menu and contains the redirects to all pages.
Main functionality:
  -Redirect to any page in the web.
Secondary functionalities:
  -Login and logout
  -Switch theme
  
Useful notes:
Css classes for managing opening a closing of dropdown menus work in the exact opposite way they should.
I have absolutely no clue about why this happens but since it works by reversing the booleans i wont be expending more time there.
  
Decission documentation:

*/

<template>
  <div
  v-if="isMenuVisible"
  @mouseover="setExpandMenuClass(Date.now())"
  @mouseleave="setContractMenuClass(Date.now())"
  id="menu-container" :class="this.hover_class"
  >
    <!-- Envelopes nav links with fixed width so changes in root width dont destroy layout -->
    <div id="menu-container-frame">

      <!-- Profile/Login container -->
      <div id="profile-container">

        <!-- Profile section -->
        <div v-if="_g_IsUserLogged">

          <div class="profile-selector-container" :class="getCorrectDropdownCss(!this.user_selector.dropdown_active, this.user_selector.options)" @click="()=>this.user_selector.dropdown_active = !this.user_selector.dropdown_active">
            <div class="profile-pic-container">
              <span id="profile-pic-center-helper"></span>
              <span class="profile-pic nav-link-icon material-icons-outlined md-24">account_circle</span>
            </div>
            <div class="profile-text-container">
                <span class="profile-title-text typo-headline-6">Mi cuenta</span>
                <span class="profile-title-text typo-body-2">{{ username }}</span>
            </div>
            <div class="nav-link-dropdown-icon-container">
              <span class="nav-link-icon material-icons-outlined md-24">arrow_drop_down</span>
            </div>
          </div>

          <!-- Profile options -->
          <div class="profile-options-container" :class="this.user_selector.dropdown_active ? 'dropdown-options-closed' : ''">
            <div class="profile-options-container-frame">

              <router-link tag="div" :to="{ name: option.url_name }" v-for="(option, subindex) in this.user_selector.options" class="nav-dropdown-option" :class="getOptionSelectedClassIfSelected(option.url_name)" :key="subindex">
                <div class="nav-link-icon-container">
                  <span class="nav-link-text">{{option.acronym}}</span>
                </div>
                <div class="nav-link-text-container">
                  <span class="nav-link-text typo-caption">{{option.name}}</span>
                </div>
              </router-link>

              <div id="log-out-button-container" @click="this.logOut">
                <div class="nav-link-icon-container">
                    <span class="nav-link-text log-out-text">CS</span>
                </div>
                <div class="nav-link-text-container">
                  <span class="nav-link-text log-out-text typo-caption">Cerrar sesión</span>
                </div>
              </div>

            </div>
          </div>

        </div>

        <!-- Login section -->
        <router-link v-else-if="(is_basico_off == false && is_avanzado_off == false) || (is_basico_off == undefined && is_avanzado_off == undefined)" id="login-selector" class="nav-selector-container" tag="div" :to="{ name: 'Login' }">
          <div class="nav-link-icon-container">
            <span class="nav-link-icon material-icons-outlined md-24">login</span>
          </div>
          <div class="nav-link-text-container">
            <span class="nav-link-text">Iniciar sesión</span>
          </div>
        </router-link>

        <div v-else>
          <div id="log-out-button-container" @click="this.logOut">
            <div class="nav-link-icon-container">
                <span class="nav-link-text log-out-text">CS</span>
            </div>
            <div class="nav-link-text-container">
              <span class="nav-link-text log-out-text typo-caption">Cerrar sesión</span>
            </div>
          </div>
          <a id="courses-button-container" href="/app/courses">
            <div class="nav-link-icon-container">
              <span class="nav-link-icon material-icons-outlined md-24">school</span>
            </div>
            <div class="nav-link-text-container">
              <span class="nav-link-text typo-caption">Próximos cursos</span>
            </div>
          </a>
        </div>
        

      </div>

      <!-- Nav links container-->
      <div id="link-container">

        <!-- Selectors section -->
        <template v-for="(selector, index) in main_selectors">

          <!-- Special selectors section -->
          <template v-if="typeof selector.options[0] == 'string'">
            <a v-if="is_admin && selector.options[0] == 'admin'" href="/admin/structure/menu/manage/main-menu" target="_blank" :key="index">
              <div class="nav-selector-container">
                <div class="nav-link-icon-container">
                  <span class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
                </div>
                <div class="nav-link-text-container">
                  <span class="nav-link-text typo-subtitle-2">{{selector.name}}</span>
                </div>
              </div>
            </a>
          </template>

          <!-- Standalone Alta Eurekers -->
          <template v-if="typeof selector.options[0] == 'string'">
            <a v-if="is_basico_asiste_avanzado && selector.options[0] == 'basico_asiste_avanzado'" href="/registro/eureker" target="_blank" :key="index">
              <div class="nav-selector-container important-highlight">
                <div class="nav-link-icon-container">
                  <span class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
                </div>
                <div class="nav-link-text-container">
                  <span class="nav-link-text typo-subtitle-2">{{selector.name}}</span>
                </div>
              </div>
            </a>
          </template>
          
          <!-- Standalone RE-Alta Eurekers -->
          <template v-if="typeof selector.options[0] == 'string'">
            <a v-if="is_avanzado_off && selector.options[0] == 'avanzado_off'" href="/area_avanzado_off" target="_blank" :key="index">
              <div class="nav-selector-container important-highlight">
                <div class="nav-link-icon-container">
                  <span class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
                </div>
                <div class="nav-link-text-container">
                  <span class="nav-link-text typo-subtitle-2">{{selector.name}}</span>
                </div>
              </div>
            </a>
          </template>

          <!-- Standalone Servicios Eurekers for basico_offs -->
          <template v-if="typeof selector.options[0] == 'string'">
            <a v-if="is_basico_off && selector.options[0] == 'basico_off'" href="/curso-de-bolsa" target="_blank" :key="index">
              <div class="nav-selector-container important-highlight">
                <div class="nav-link-icon-container">
                  <span class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
                </div>
                <div class="nav-link-text-container">
                  <span class="nav-link-text typo-subtitle-2">{{selector.name}}</span>
                </div>
              </div>
            </a>
          </template>

          <!-- Standalone selectors section -->
          <router-link v-else-if="isSelectorVisible(selector) && isEmpty(getVisibleOptions(selector))" tag="div" :to="{ name: selector.url_name }" class="nav-selector-container" :class="getSelectedClassIfSelected(selector)" :key="index">
            <div class="nav-link-icon-container">
              <div v-if="selector.name == 'Foro'" style="display: flex; flex-direction: row; margin-left: 22px;">
                <span class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
                <div class="circle" v-if="forumNotificationCount > 0 && showForumNotifications">
                </div>
              </div>
              <span v-else class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
            </div>
            <div class="nav-link-text-container">
              <span class="nav-link-text typo-subtitle-2">{{selector.name}}</span>
            </div>
          </router-link>

          <!-- Dropdown selectors section -->
          <div v-else-if="isSelectorVisible(selector)" :key="index">

            <!-- Dropdown main selector -->
            <div class="nav-selector-container" :class="getCorrectDropdownCss(!selector.dropdown_active, getVisibleOptions(selector))" @click="()=>selector.dropdown_active = !selector.dropdown_active">
              <div class="nav-link-icon-container">
                <span class="nav-link-icon material-icons-outlined md-24">{{selector.icon}}</span>
              </div>
              <div class="nav-link-text-container">
                <span class="nav-link-text typo-subtitle-2">{{selector.name}}</span>
              </div>
              <div class="nav-link-dropdown-icon-container">
                <span class="nav-link-icon material-icons-outlined md-24">arrow_drop_down</span>
              </div>
            </div>

            <!-- Dropdown options -->
            <div class="nav-dropdown-options-container" :class="selector.dropdown_active ? 'dropdown-options-closed' : ''">
              <div class="nav-dropdown-options-container-frame">

                <router-link tag="div" :to="{ name: option.url_name }" v-for="(option, subindex) in getVisibleOptions(selector)" class="nav-dropdown-option" :class="getOptionSelectedClassIfSelected(option.url_name)" :key="subindex">
                  <div class="nav-link-icon-container">
                    <span class="nav-link-text">{{option.acronym}}</span>
                  </div>
                  <div class="nav-link-text-container">
                    <span class="nav-link-text typo-caption">{{option.name}}</span>
                  </div>
                </router-link>

              </div>
            </div>

          </div>
        </template>
        
      </div>

      <!-- Bottom pinned nav links container -->
      <div id="bottom-pinned-container">

        <!-- Referrals -->
        <router-link v-if="_g_IsUserLogged && isActiveRole && referralsEnabled" tag="div" :to="{ name: 'Referrals' }" class="nav-selector-container" :class="getSelectedClassIfSelected({ url_name: 'Referrals', options: [], extra_names: [] })">
          <div class="nav-link-icon-container">
            <span class="nav-link-icon material-icons-outlined md-24">card_giftcard</span>
          </div>
          <div class="nav-link-text-container">
            <span class="nav-link-text">Referidos</span>
          </div>
        </router-link>

        <!-- Zopim Chat -->
        <div v-if="_contieneChat(_g_User.roles) && (zopimDisplaySetting === 1 || zopimDisplaySetting === 2)" id="chat-selector" class="nav-selector-container" :class="{ 'chat-loading': !zopimReady }" @click="toggleZopimChat">
          <div class="nav-link-icon-container">
            <span v-if="zopimReady" class="nav-link-icon material-icons-outlined md-24">chat</span>
            <span v-else class="nav-link-icon material-icons-outlined md-24 chat-spinner">sync</span>
          </div>
          <div class="nav-link-text-container">
            <span class="nav-link-text">{{ zopimReady ? 'Chat' : 'Cargando...' }}</span>
          </div>
        </div>

        <!-- Notifications -->
        <div id="notification-selector" class="nav-selector-container" @click="_handlerViewNotificationsContainer">
          <div class="nav-link-icon-container">
            <div style="display: flex; flex-direction: row; margin-left: 22px;">
              <span class="nav-link-icon material-icons-outlined md-24">notifications</span>
              <div class="circle" v-if="contador_notificaciones != 0">
              </div>
            </div>
          </div>
          <div class="nav-link-text-container">
            <span class="nav-link-text">Notificaciones</span>
          </div>
        </div>

        <!-- Theme switcher -->
        <div id="theme-selector" class="nav-selector-container" @click="changeInterfacePlatinum">
          <div class="nav-link-icon-container">
            <span class="nav-link-icon material-icons-outlined md-24">contrast</span>
          </div>
          <div class="nav-link-text-container">
            <span class="nav-link-text">Cambiar tema de color</span>
          </div>
        </div>

        <!-- Fullscreen button -->
        <div id="fullscreen-selector" class="nav-selector-container" @click="setFullscreen">
          <div class="nav-link-icon-container">
            <span class="nav-link-icon material-symbols-outlined md-24">fullscreen</span>
          </div>
          <div class="nav-link-text-container">
            <span class="nav-link-text">Pantalla completa</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from "@/services/auth";
import forumApi from '@/services/forumApi';

import mainMenu from "@/components/menu/configs/main_menu.json";
import userMenu from "@/components/menu/configs/user_menu.json";
import APICaller from "@/components/codeComponents/APICaller.js";

import { mapGetters, mapMutations } from "vuex";

export default {
  mixins: [APICaller],
  data() {
    return {
      main_selectors: mainMenu,
      user_selector: userMenu,
      current_route: "",
      logged_in: false,

      last_menu_hover: -1,
      menu_hover_open_timeout_ms: 250,
      menu_hover_close_timeout_ms: 250,
      hover_class: "menu-closed",
      username: '',
      is_admin: false,
      uid: 0,
      is_basic_user: "",
      is_basico_asiste_avanzado: false,
      router_in_stockchart: false,
      notifications_opened: false,
      contador_notificaciones: 0,
      forumNotificationCount: 0,
      showForumNotifications: true,
      is_avanzado_off: false,
      is_basico_off: false,
      referralsEnabled: false,
      zopimDisplaySetting: 0,
      zopimReady: false,
      zopimDebugLog: [],
      zopimDebugUserId: 4901,
    };
  },
  watch: {
    '$route.name': {
      handler: function() {
        this.current_route = this.$route.name;
      }
    }
  },
  created(){
    this._getUsername();
    this.current_route = this.$route.name;
    // Load forum notification setting from localStorage
    this.loadForumNotificationSetting();
    this.checkReferralsEnabled();
    this.loadZopimDisplaySetting();
  },
  mounted() {
    var waiting_for_user = setInterval(()=>{
      if(this._g_User.uid != undefined){
        this.initUserInfo();
        this._getAllUserNotifications();
        this._getForumNotifications();
        clearInterval(waiting_for_user);
      }
    },200)
    const current_uri = location.pathname;
    const uri_elems = current_uri.split("/");
    if(uri_elems.length > 2) {
      if(uri_elems[2] === 'graficador-dinamico') {
        this.router_in_stockchart = true;
      } 
    }
    
    // Listen for forum notification setting changes
    this.$root.$on('forumNotificationSettingChanged', this.handleForumNotificationSettingChange);
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off('forumNotificationSettingChanged', this.handleForumNotificationSettingChange);
  },
  computed: {
    ...mapGetters(['_g_ThemeName']),
    ...mapGetters(['_g_IsUserLogged', '_g_UserId', "_g_User", "_g_UserFeatures"]),
    isMenuVisible() {
      const certAndLoggedOut = this.current_route === 'UserCertificates' && !this._g_IsUserLogged;
      return this.current_route !== 'Login' && this.current_route !== 'InformeFlow' && this.current_route !== 'Promo' && !certAndLoggedOut;
    },
    isActiveRole() {
      const user = this._g_User;
      if (!user) return false;
      return user.is_bronze_user || user.is_silver_user || 
             user.is_gold_user || user.is_platinum_user || 
             user.is_pre_user || user.is_developer_user;
    }
  },
  methods: {
    //Ini methods

    // Zopim debug logging (only for specific user)
    _zopimDebugLog(step, data = {}) {
      if (this._g_User && this._g_User.uid == this.zopimDebugUserId) {
        const entry = {
          step: step,
          time: new Date().toISOString(),
          ...data
        };
        this.zopimDebugLog.push(entry);
        console.log('[ZOPIM_DEBUG]', step, data);
      }
    },

    _sendZopimDebugToServer() {
      if (this._g_User && this._g_User.uid == this.zopimDebugUserId && this.zopimDebugLog.length > 0) {
        const debugData = {
          logs: this.zopimDebugLog,
          finalState: {
            zopimReady: this.zopimReady,
            zopimDisplaySetting: this.zopimDisplaySetting,
            zeSnippetPresent: !!document.getElementById('ze-snippet'),
            windowZEExists: typeof window.zE === 'function',
          },
          userInfo: {
            uid: this.uid,
            is_basic_user: this.is_basic_user,
            is_basico_off: this.is_basico_off,
            is_avanzado_off: this.is_avanzado_off,
            hasRoleChat: this._contieneChat(this._g_User.roles),
            roles: Object.values(this._g_User.roles || {}),
          },
          browser: {
            userAgent: navigator.userAgent,
            url: window.location.href,
            search: window.location.search,
          }
        };

        axios.post(process.env.VUE_APP_API + '/eurekers/vdb/zopim-debug', {
          debug_data: debugData
        }).catch(err => console.error('[ZOPIM_DEBUG] Error sending to server:', err));
      }
    },

    initializeZopim() {
      this._zopimDebugLog('initializeZopim_start', {
        hasRoles: !!this._g_User.roles,
        rolesContent: this._g_User.roles ? Object.values(this._g_User.roles) : null,
      });

if(this._contieneChat(this._g_User.roles)){
        this._zopimDebugLog('hasChat_true');
        var self = this;
        const snippetKey = 'e469a181-7e42-4a98-ac10-6d3bc1471048';

        const existingSnippet = document.getElementById('ze-snippet');
        if (existingSnippet) {
          this._zopimDebugLog('ze_snippet_already_exists');
        } else {
          const script = document.createElement('script');
          script.id = 'ze-snippet';
          script.async = true;
          script.src = `https://static.zdassets.com/ekr/snippet.js?key=${snippetKey}`;
          script.onerror = function(e) {
            self._zopimDebugLog('ze_snippet_load_error', { error: e.type || 'unknown' });
            self._sendZopimDebugToServer();
          };
          script.onload = function() {
            self._zopimDebugLog('ze_snippet_loaded_successfully');
          };
          document.head.appendChild(script);
          this._zopimDebugLog('ze_snippet_inserted_into_dom', { key: snippetKey });
        }

        let waitForZendeskCount = 0;
        const waitForZendesk = setInterval(function() {
          waitForZendeskCount++;
          if (typeof window.zE === 'function') {
            clearInterval(waitForZendesk);
            self._zopimDebugLog('ze_available', { iterations: waitForZendeskCount });
            
            // Mark as ready immediately when zE is available
            self.zopimReady = true;
            self._zopimDebugLog('zopimReady_true_ze_available');

            // Configure visibility immediately
            setTimeout(function() {
              try {
                if (self.zopimDisplaySetting === 1) {
                  window.zE('webWidget', 'hide');
                  self._zopimDebugLog('floating_widget_hidden');
                } else {
                  window.zE('webWidget', 'show');
                  self._zopimDebugLog('floating_widget_shown');
                }
                self._sendZopimDebugToServer();
              } catch(e) {
                self._zopimDebugLog('config_error', { error: e.message });
              }
            }, 500);
          } else if (waitForZendeskCount % 25 === 0) {
            self._zopimDebugLog('waitForZendesk_still_waiting', { iterations: waitForZendeskCount });
          }

          if (waitForZendeskCount >= 150) {
            clearInterval(waitForZendesk);
            self._zopimDebugLog('waitForZendesk_timeout', { iterations: waitForZendeskCount });
            self._sendZopimDebugToServer();
          }
        }, 200);
      } else {
        this._zopimDebugLog('hasChat_false');
        this._sendZopimDebugToServer();
      }
    },

    _contieneChat: function(obj) {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (typeof obj[key] === 'string' && obj[key].includes('Chat')) {
            return true;
          }
        }
      }
      return false;
    },

    initUserInfo: function(){
      this.is_basico_off = this._g_User.is_basico_off;
      this.is_avanzado_off = this._g_User.is_avanzado_off;
      this.is_basico_asiste_avanzado = this._g_User.is_basico_asiste_avanzado;
      this.uid = this._g_User.uid;
      this.is_admin = this._g_User.is_admin_user;
      this.is_basic_user = this._g_User.is_basic_user;

      this._zopimDebugLog('initUserInfo_called', {
        uid: this.uid,
        is_basico_off: this.is_basico_off,
        is_avanzado_off: this.is_avanzado_off,
        is_basic_user: this.is_basic_user,
        zopimDisplaySetting: this.zopimDisplaySetting,
      });

      this.initializeZopim();
    },

    //Open-close functionality

    toggleHoverClass(hover_time, hover_class) {
      this.last_menu_hover = hover_time;
      let checkChangesFunction = function() {
        if(hover_time == this.last_menu_hover) {
          this.hover_class = hover_class;
        }
      }
      return checkChangesFunction.bind(this);
    },

    setExpandMenuClass(hover_time) {
      setTimeout(this.toggleHoverClass(hover_time, "menu-open"), this.menu_hover_open_timeout_ms);
    },
    setContractMenuClass(hover_time) {
      setTimeout(this.toggleHoverClass(hover_time, "menu-closed"), this.menu_hover_close_timeout_ms);
    },

    //Theming

    switchTheme() {
      if(localStorage.getItem('dark_theme') != undefined) {
        localStorage.setItem('dark_theme', !this._g_ThemeName);
        this.changeInterfacePlatinum()
      }
    },

    changeInterfacePlatinum() {

      let success = () => {
        location.reload();
      };

      let url = '/usuarios/change-gd-interface-color';

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('002', 'Error cambiando el tema de color.');

      this._getAPICall(url, successHandler, failureHandler);
    },

    //Log out method

    logOut() {

      let success = () => {
        localStorage.removeItem('user_access_token');
        location.reload();
      };
      let url = '/api/v1/users/user/log-out';

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('003', 'Error cerrando la sesión.');

      this._getAPICall(url, successHandler, failureHandler);
    },


    //HTML vue methods

    // Return selected class if selector equals current route or matches any extra names
    getSelectedClassIfSelected(selector) {
      if (this.current_route === selector.url_name) {
        return 'selected';
      }

      if (Array.isArray(selector.extra_names) && selector.extra_names.includes(this.current_route)) {
        return 'selected';
      }

      return '';
    },
    
    //Returns selected class if parameter matches with current router url
    getOptionSelectedClassIfSelected(selector_url) {
      return this.current_route == selector_url ? 'option-selected' : '';
    },

    //Returns whether an array is empty
    isEmpty(list) {
      return list.length === 0;
    },

    canAccessAdminOnlyContent() {
      return !!(this.is_admin || (this._g_User && this._g_User.is_developer_user));
    },

    isOptionVisible(option) {
      return !option.admin_only || this.canAccessAdminOnlyContent();
    },

    getVisibleOptions(selector) {
      if (!Array.isArray(selector.options) || !selector.options.length) {
        return selector.options || [];
      }

      if (typeof selector.options[0] === 'string') {
        return selector.options;
      }

      return selector.options.filter(option => this.isOptionVisible(option));
    },

    isSelectorVisible(selector) {
      if (selector.admin_only && !this.canAccessAdminOnlyContent()) {
        return false;
      }

      if (!Array.isArray(selector.options) || !selector.options.length) {
        return true;
      }

      if (typeof selector.options[0] === 'string') {
        return true;
      }

      return this.getVisibleOptions(selector).length > 0;
    },

    //Returns true if any option in the array parameter (options) has a url matching with current router url
    isChildSelected(options) {
      let res = false;
      for (let i = 0; i < options.length; i++) {
        res = options[i].url_name == this.current_route;
        if(res) {break;}
      }
      return res;
    },

    //Returns needed dropdown styles
    getCorrectDropdownCss(dropdown_active, options) {
      let final_style = "";
      let isChildSelected = this.isChildSelected(options);
      if(dropdown_active && isChildSelected) {
        final_style = 'selected-dropdown child-selected';
      }
      else if(dropdown_active) {
        final_style = 'selected-dropdown';
      }
      else if(isChildSelected) {
        final_style = 'child-selected';
      }

      return final_style;
    },

    _getUsername(){
      axios.get(process.env.VUE_APP_API + '/api/v1/users/user/name', { headers: authHeader() })
      .then(
        response => {
          this.username = response.data.name
        },
        error => {
        }
      )
    },
    _handlerViewNotificationsContainer: function(){
      setTimeout(this.toggleHoverClass(0, "menu-closed"), 0);
      if(this.notifications_opened){
        let success = response => {
          this.notifications_opened = false
          this.$emit("close_notification_container")
          this._getAllUserNotifications()
        }

        let url = "/api/v1/eurekers-notifications/read-notifications/" + this._g_UserId;

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('316', 'Error leyendo las notificaciones.');

        this._getAPICall(url, successHandler, failureHandler);
      }else{
        this.notifications_opened = true
        this.$emit("open_notification_container")
      }
    },
    _getAllUserNotifications: function(){
      let success = response => {
        this.contador_notificaciones = 0
        let notifications = this._checkTimestamps(response.data);
        notifications.forEach(element=>{
          if(element.status == '0'){
            this.contador_notificaciones++
          }
        })
      }

      let url = "/api/v1/eurekers-notifications/" + this._g_UserId;

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('317', 'Error recuperando las notificaciones.');

      this._getAPICall(url, successHandler, failureHandler);
    },
    _checkTimestamps: function(arr) {
      var notifications = [];
      var today = new Date().getTime(); // get current timestamp
      for(var i = 0; i < arr.length; i++) {
        if(arr[i].date*1000 <= today) {
          notifications.push(arr[i]);
        }
      }
      return notifications;
    }, 

    _reloadPage(){
      window.location.reload();
    },

    setFullscreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen()
          .then(() => this.$vueOnToast.pop('success', "Cambio en el modo de pantalla"))
          .catch((err) => this.$vueOnToast.pop('error', "Error pasando a pantalla completa"));
      } else {
        document.documentElement.requestFullscreen();
      }
    },

    // Forum notification methods
    _getForumNotifications() {
      if (!this._g_IsUserLogged) {
        return;
      }
      
      forumApi.get('/forum/api/notifications')
        .then(response => {
          if (response.data) {
            this.forumNotificationCount = response.data.unsilenced_count || 0;
          }
        })
        .catch(err => {
          console.error('Error fetching forum notifications:', err);
          this.forumNotificationCount = 0;
        });
    },

    loadForumNotificationSetting() {
      const saved = localStorage.getItem('show_forum_notifications_menu');
      this.showForumNotifications = saved === null ? true : saved === 'true';
    },

    handleForumNotificationSettingChange(enabled) {
      this.showForumNotifications = enabled;
      localStorage.setItem('show_forum_notifications_menu', enabled.toString());
    },

    checkReferralsEnabled() {
      axios.get(process.env.VUE_APP_API + '/api/v1/referrals/settings')
        .then(response => {
          if (response.data.status === 'success') {
            this.referralsEnabled = response.data.enabled;
          }
        })
        .catch(error => {
          console.error('Error checking referrals setting:', error);
          this.referralsEnabled = false; // Default to hidden on error
        });
    },

    loadZopimDisplaySetting() {
      axios.get(process.env.VUE_APP_API + '/adminmenu/zopim-display-setting')
        .then(response => {
          if (response.data.success) {
            this.zopimDisplaySetting = parseInt(response.data.value);
            this._zopimDebugLog('zopimDisplaySetting_loaded', { value: this.zopimDisplaySetting });
          } else {
            this._zopimDebugLog('zopimDisplaySetting_response_not_success', { response: response.data });
          }
        })
        .catch(error => {
          console.error('Error loading zopim display setting:', error);
          this._zopimDebugLog('zopimDisplaySetting_error', { error: error.message || 'unknown' });
          this.zopimDisplaySetting = 0; // Default to floating
        });
    },

    toggleZopimChat() {
      // Don't do anything if widget is still loading
      if (!this.zopimReady) {
        return;
      }
      
      if (typeof window.zE === 'function') {
        try {
          // Open the chat in a new popout window
          window.zE('webWidget', 'popout');
        } catch(e) {
          console.error('[CHAT] Error opening popout:', e);
          // Fallback: try to open normally if popout fails
          window.zE('webWidget', 'show');
          window.zE('webWidget', 'open');
        }
      }
    }
  },
}
</script>

<style lang="scss">
//modifiable attributes
$selector_height: 47px;
$login_selector_focus_padding: 15px;
$login_selector_not_focus_padding: 7.5px;
$login_selector_focus_font_size: 18px;
$login_selector_focus_icon_size: 28px;
$closed_width: 64px; //Deberian ser 72 pero si no igual no esta para la master porque descuadra todo
$open_width: 315px;
$border_color: #868993;
$profile_pic_size: 27px;
$profile_padding: 15px;

:root {
  -webkit-user-select: none; /* Safari */        
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

#menu-container {
  background-color: var(--color-primary-primary);
  color: var(--color-typography-on-primary);
  font-weight: bold;
  position: fixed;
  z-index: 999;
  top: 0px;
  cursor: pointer;
  height: 100vh;
  transition: width 0.15s ease-in;
  overflow: hidden;
  border-right: var(--menu-border-size) solid #868993;
}

#menu-container-frame {
  width: $open_width;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

#login-selector {
  padding: $login_selector_not_focus_padding 0;
  transition: padding, 0.2s;
  transition: font-size, 0.2s;
}

#login-selector:hover {
  padding: $login_selector_focus_padding 0px;
  font-size: $login_selector_focus_font_size;
}

.md-24 {
  font-size: 20px !important;
}

#login-selector:hover .md-24 {
  transition: font-size, 0.2s;
}

#login-selector:hover .md-24 {
  font-size: $login_selector_focus_icon_size !important;
}

#profile-container {
  order: 1;
  border-bottom: 1px solid $border_color;
}

#link-container {
  order: 2;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

#bottom-pinned-container {
  order: 3;
  margin-top: auto;
  border-top: 1px solid $border_color;
}

.menu-closed {
  width: $closed_width;
}

.menu-open {
  width: $open_width;
}

.nav-selector-container {
  height: $selector_height;
}

.profile-selector-container:hover {
  background-color: var(--color-primary-secondary);
  transition: background-color, 0.2s;
}

.nav-selector-container:hover {
  background-color: var(--color-primary-secondary);
  transition: background-color, 0.2s;
}
.nav-selector-container.important-highlight:hover {
  background-color: #00add8;
  transition: background-color, 0.2s;
}
.important-highlight {
  background-color: orange;
}

.nav-link-icon-container, .nav-link-dropdown-icon-container, .profile-pic-container{
  width: $closed_width;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}

.nav-link-icon {
  line-height: $selector_height !important;
  text-align: center;
}

.nav-link-text-container, .profile-text-container {
  display: inline-block;
  vertical-align: top;
}
.profile-text-container {
  margin-top: 6px;
}
.nav-link-text {
  font-size: 14px;
  line-height: $selector_height !important;
  text-align: center;
}

#notification-container {
  border-top: 1px solid $border_color;
}

.nav-link-icon-container .material-icons-outlined, .nav-link-dropdown-icon-container .material-icons-outlined {
  margin: 0px !important;
}

.selected, .selected:hover {
  background-color: var(--color-accent-primary);
}

.child-selected {
  background-color: var(--color-primary-secondary);
}

.selected-dropdown .nav-link-dropdown-icon-container {
  transform: rotate(-180deg);
}

.nav-link-dropdown-icon-container {
  transition: all .25s ease-out;
  float: right;
}

.nav-dropdown-option {
  background-color: var(--color-primary-900);
  transition: background-color 0.2s;
}

.nav-dropdown-option:hover {
  background-color: var(--color-primary-secondary);
}

.option-selected, .option-selected:hover {
  background-color: var(--color-accent-primary);
}

.nav-dropdown-options-container, .profile-options-container {
  overflow: hidden;
  overflow-y: auto;
  transition: opacity 0.5s;
}

.dropdown-options-closed {
  height: 0px;
  opacity: 0%;
}

.profile-selector-container {
  padding: $profile_padding 0;
  height: $selector_height;
}

.profile-title-text {
  display: block;
}

.profile-pic-container {
  height: 100%;
}

#profile-pic-center-helper {
  height: 100%;
  vertical-align: middle;
  display: inline-block;
}

.log-out-text {
  color: var(--color-other-error);
}

#log-out-button-container {
  transition: background-color, 0.2s;
}

#log-out-button-container:active {
  background-color: var(--color-accent-primary);
}

#log-out-button-container:active .log-out-text {
  color: var(--color-typography-on-primary) !important;
}

.profile-pic {
  display: inline-block;
  vertical-align: middle;
  //height: $profile_pic_size;
  font-size: $profile_pic_size !important;
}

.circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 9px;
}

.chat-loading {
  opacity: 0.6;
  cursor: wait;
}

.chat-spinner {
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0");
</style>

<style lang="scss" scoped>
a {
  text-decoration: unset;
  color: unset;
}
</style>
